import {PRODUCT_TYPES} from 'constants/product';
import {CartItemType} from 'desktop/pages/cart/types';
import {QuoteItemV2OptionType} from 'desktop/pages/cart/types/quoteItem';
import {
    CheckoutItemOptionType,
    ProductType as CheckoutItemProductType,
} from 'desktop/types/checkoutItemsType';
import {flags} from 'libs/rollout';
import {
    ContactOptionsType,
    OrderDetailsItemOptionType,
    ProductType as OrderDetailsProductType,
} from 'types/orderDetailsTypes';

/**
 * check if productType is eyeglasses and check dLensTintsEgCart flag and get default img or img with tints
 */
export const getFeatureAwareImage = (
    product: OrderDetailsProductType | CheckoutItemProductType | CartItemType,
    imageWithoutTintUrl: string,
    productLensTypeOptions?:
        | Record<
              string,
              OrderDetailsItemOptionType | CheckoutItemOptionType | QuoteItemV2OptionType
          >
        | ContactOptionsType
        | CheckoutItemOptionType[],
): string => {
    if (!flags.dLensTintsEgCart.isEnabled() || product.type !== PRODUCT_TYPES.EYEGLASSES) {
        return imageWithoutTintUrl;
    }

    const hasLightAdjustingOption =
        productLensTypeOptions &&
        Object.values(productLensTypeOptions).some(
            item => item.option?.alias === 'light_adjusting',
        );

    return hasLightAdjustingOption ? imageWithoutTintUrl : (product.imageWithTintUrl as string);
};
